export default __webpack_public_path__ + "static/media/home-top3.9ef834d8.jpg";